import React from 'react'
import { RouteProps } from 'react-router-dom'

import RegisterTemplate from '../../../templates/Register'
import { useRegisterTemplateProps } from '../../../templates/Register/useProps'

const RegisterPage: React.FC<RouteProps> = () => {
  const templateProps = useRegisterTemplateProps()

  return <RegisterTemplate {...templateProps} />
}

export default RegisterPage
